<template>
  <section class="card">
    <SidebarAccount />

    <div class="card__myCards">
      <h2 class="card__myCards--title">Cartões</h2>
      <div class="card__myCards--warning" v-if="!closeWarning">
        <p>
          Por razões de segurança, só é possível editar ou cadastrar um novo
          cartão durante o processo de compra.
        </p>
        <span @click="closeWarning = !closeWarning">X</span>
      </div>
      <div class="card__allCards">
        <div class="card__allCards--item">
          <div class="card__allCards--item--header">
            <span>5632 **** **** 5487</span>

            <a href="javascript:void(0)"> <i class="far fa-trash-alt"></i></a>
          </div>
          <div class="card__allCards--item--body">
            <span>Titular do Cartão: JOÃO V C GOULARTE</span>
            <span>Validade do Cartão: 02/28</span>
            <span>CPF: 406.243.478.42</span>
          </div>
        </div>

        <div class="card__allCards--item">
          <div class="card__allCards--item--header">
            <span>5632 **** **** 5487</span>

            <a href="javascript:void(0)"> <i class="far fa-trash-alt"></i></a>
          </div>
          <div class="card__allCards--item--body">
            <span>Titular do Cartão: JOÃO V C GOULARTE</span>
            <span>Validade do Cartão: 02/28</span>
            <span>CPF: 406.243.478.42</span>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SidebarAccount from "../SidebarAccount";
export default {
  data() {
    return {
      closeWarning: false,
    };
  },
  components: {
    SidebarAccount,
  },
};
</script>

<style lang="scss" scoped>
.card {
  max-width: 90%;
  margin: 0 auto;
  display: flex;

  @media (max-width: 440px) {
    max-width: 100%;
    flex-direction: column;
  }

  @media (min-width: 1920px) {
    max-width: 60%;
  }

  @media (min-width: 1400px) and (max-width: 1919px) {
    max-width: 80%;
  }

  &__myCards {
    width: 80%;
    padding-top: 60px;

    @media (max-width: 440px) {
      width: 100%;
      padding: 40px 20px 0 20px;
    }

    &--title {
      color: #424242;
      font-weight: bold;
      padding-bottom: 20px;
    }

    &--warning {
      padding: 15px;
      background: #ffce00;
      border-radius: 5px;
      color: #3f3f3f;
      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        cursor: pointer;
        font-weight: bold;
        color: #005a64;
        font-size: 1.125rem;
      }
    }
  }

  &__allCards {
    display: flex;
    flex-wrap: wrap;

    &--item {
      border: 1px solid #a1a1a1;
      border-radius: 5px;
      width: 40%;
      padding: 10px;
      color: #424242;
      margin: 30px 10px;

      @media (max-width: 440px) {
        width: 100%;
        margin: 15px 0;
      }

      &--header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #a1a1a1;
        padding: 10px 0;

        span {
          font-weight: bold;
        }
        a i {
          font-size: 1.125rem;
          color: #4cdddd;
        }
      }

      &--body {
        display: flex;
        flex-direction: column;
        line-height: 1.7;
        padding: 10px 0;
      }
    }
  }
}
</style>